module.exports = __webpack_public_path__ + "563ca1f1a8342a7761aa7290b4e84bd8.jpg";